import React from 'react'
import { Col, Row, Card, Container } from "react-bootstrap";
import '../css/footer.css'
function Footer() {
  return (
      <>
          <Row className=" footer-row p-3" >
              <Col className='coll' xs={12} sm={6} md={4} lg={2}  >
            
                  <h4 className=''>Browse by</h4>
                  <h5>Brand</h5>
                  <h5>Product</h5>
                  <h5>Category</h5>
                  <h5>Project</h5>
                  <h5>
                Sales
                  </h5>
              
              </Col>  
              <Col xs={12} sm={6} md={4} lg={2} className='coll'  >
            
              <h4 className=''>Quick links</h4>
                  <h5>In store pickup </h5>
                  <h5>Gift Cards</h5>
                  <h5>Afterpay</h5>
                  <h5>Shop</h5>
                  <h5>Store Locator
                  </h5>
                  <h5>FAQ</h5>
              
              </Col>  
              <Col xs={12} sm={6} md={4} lg={2} className='coll'  >
            
              <h4 className=''>Order Info</h4>
                  <h5>Order Status</h5>
                  <h5>Payment Shippings</h5>
              
                  <h5>Shipping</h5>
                  <h5>Returns</h5>
                  <h5>Exchanges</h5>
                  <h5>Order Changes</h5>
              </Col>  
              <Col className='coll' xs={12} sm={6} md={12} lg={2} >
             
              <h4 className=''>Customer service</h4>
                  <h5>Help Center</h5>
                  <h5>Product Recalls</h5>
                  <h5>Shipping</h5>
                  <h5>Feedback</h5>
                  <h5>Store Picjup</h5>
                  <h5>Contact Us</h5>
              </Col>  
              <Col className='last-col coll' xs={12} sm={12} md={12} lg={4}>
              
              <h4 className=''>Sign up for our newsletter</h4>
                  <h5>Add your e-mail address to sign up for out monthly emails and to receive promotional offers</h5>
                  <div>
                      <input placeholder='Email address' />
                      <button>Subscribe</button>
                  </div>
              </Col> 
             
          </Row>
      </>
  )
}

export default Footer